// Import all icons
import audiovideo from "components/Icons/QuickAccessBarIcons/audiovideo.svg";
import calls from "components/Icons/QuickAccessBarIcons/calls.svg";
import sms from "components/Icons/QuickAccessBarIcons/sms.svg";
import photo from "components/Icons/QuickAccessBarIcons/photo.svg";
import whatsapp from "components/Icons/QuickAccessBarIcons/whatsapp.svg";
import keylogger from "components/Icons/QuickAccessBarIcons/keylogger.svg";
import screen from "components/Icons/QuickAccessBarIcons/screen.svg";
import webHistory from "components/Icons/QuickAccessBarIcons/webHistory.svg";
import facebook from "components/Icons/QuickAccessBarIcons/facebook.svg";
import viber from "components/Icons/QuickAccessBarIcons/viber.svg";
import mail from "components/Icons/QuickAccessBarIcons/mail.svg";
import skype from "components/Icons/QuickAccessBarIcons/skype.svg";
import tinder from "components/Icons/QuickAccessBarIcons/tinder.svg";
import wechat from "components/Icons/QuickAccessBarIcons/wechat.svg";
import line from "components/Icons/QuickAccessBarIcons/line.svg";
import instagram from "components/Icons/QuickAccessBarIcons/instagram.svg";
import snapchat from "components/Icons/QuickAccessBarIcons/snapchat.svg";
import zolo from "components/Icons/QuickAccessBarIcons/zolo.svg";
import imo from "components/Icons/QuickAccessBarIcons/imo.svg";
import bip from "components/Icons/QuickAccessBarIcons/bipMssangerIcon.svg";
import justtalk from "components/Icons/QuickAccessBarIcons/justtalk.svg";
import botim from "components/Icons/QuickAccessBarIcons/botim.svg";
import signal from "components/Icons/QuickAccessBarIcons/signal.svg";
import discord from "components/Icons/QuickAccessBarIcons/discord.svg";
import vk from "components/Icons/QuickAccessBarIcons/vk.svg";
import tiktok from "components/Icons/QuickAccessBarIcons/tiktok.svg";
import search from "components/Icons/QuickAccessBarIcons/search.svg";
import youtube from "components/Icons/QuickAccessBarIcons/youtube.svg";
import kakoa from "components/Icons/QuickAccessBarIcons/kakoa.svg";
import clipboard from "components/Icons/QuickAccessBarIcons/clipboard.svg";
import dataLiberation from "components/Icons/QuickAccessBarIcons/dataLiberation.svg";
import tNotifier from "components/Icons/QuickAccessBarIcons/notifierApplocation.svg";
import help from "components/Icons/QuickAccessBarIcons/help.svg";
import telegram from "components/Icons/QuickAccessBarIcons/telegram.svg";
import twitter from "components/Icons/QuickAccessBarIcons/twitter.svg";
import mms from "components/Icons/InstantIMPageIcons/mms.svg";
import notification from "components/Icons/QuickAccessBarIcons/notification.svg";
import googlemeet from "components/Icons/QuickAccessBarIcons/googlemeet.svg";
import QQ from "components/Icons/QuickAccessBarIcons/QQ.svg";
// import MTeams from "components/Icons/QuickAccessBarIcons/mteams.svg";

// Instant IM Page Icons
import whatsappIM from "components/Icons/InstantIMPageIcons/whatsapp.svg";
import facebookIM from "components/Icons/InstantIMPageIcons/facebook.svg";
import viberIM from "components/Icons/InstantIMPageIcons/Viber.svg";
import mailIM from "components/Icons/InstantIMPageIcons/mail.svg";
import skypeIM from "components/Icons/InstantIMPageIcons/skype.svg";
import tinderIM from "components/Icons/InstantIMPageIcons/Tinder.svg";
import wechatIM from "components/Icons/InstantIMPageIcons/wechat.svg";
import lineIM from "components/Icons/InstantIMPageIcons/Line.svg";
import instagramIM from "components/Icons/InstantIMPageIcons/instagram.svg";
import snapchatIM from "components/Icons/InstantIMPageIcons/Snapchat.svg";
import zoloIM from "components/Icons/InstantIMPageIcons/Zolo.svg";
import imoIM from "components/Icons/InstantIMPageIcons/Imo.svg";
import bipIM from "components/Icons/InstantIMPageIcons/BipMessanger.svg";
import justtalkIM from "components/Icons/InstantIMPageIcons/JustTalk.svg";
import botimIM from "components/Icons/InstantIMPageIcons/Botim.svg";
import signalIM from "components/Icons/InstantIMPageIcons/Signal.svg";
import discordIM from "components/Icons/InstantIMPageIcons/Discord.svg";
import vkIM from "components/Icons/InstantIMPageIcons/VK.svg";
import tiktokIM from "components/Icons/InstantIMPageIcons/Tiktok.svg";
import searchIM from "components/Icons/InstantIMPageIcons/search.svg";
import youtubeIM from "components/Icons/InstantIMPageIcons/youtube.svg";
import kakoaIM from "components/Icons/InstantIMPageIcons/Kakoa.svg";
import telegramIM from "components/Icons/InstantIMPageIcons/Telegram.svg";
import twitterIM from "components/Icons/InstantIMPageIcons/twitter.svg";
import mmsIM from "components/Icons/InstantIMPageIcons/mms.svg";
import googlemeetIM from "components/Icons/QuickAccessBarIcons/googlemeet.svg";
import qqIM from "components/Icons/QuickAccessBarIcons/QQ.svg";
// import TeamsIM from "components/Icons/QuickAccessBarIcons/mteams.svg";


// Main icons configuration object
const ICON_CONFIG = {
  // Quick Access Bar Icons
  quickAccess: {
    audiovideo: audiovideo,
    calls: calls,
    calllog: calls,
    sms: sms,
    photo: photo,
    photos: photo,
    whatsapp: whatsapp,
    keylogger: keylogger,
    screen: screen,
    webHistory: webHistory,
    webhistory: webHistory,
    facebook: facebook,
    viber: viber,
    mail: mail,
    skype: skype,
    tinder: tinder,
    wechat: wechat,
    line: line,
    instagram: instagram,
    snapchat: snapchat,
    zolo: zolo,
    imo: imo,
    bip: bip,
    justtalk: justtalk,
    botim: botim,
    signal: signal,
    discord: discord,
    vk: vk,
    tiktok: tiktok,
    mms: mms,
    search: search,
    youtube: youtube,
    kakoa: kakoa,
    clipboard: clipboard,
    dataLiberation: dataLiberation,
    tispynotifier: tNotifier,
    tispyNotifier: tNotifier,
    help: help,
    telegram: telegram,
    twitter: twitter,
    notification: notification,
    googlemeet: googlemeet,
    qq: QQ,
    whatsapp_screen: whatsapp,
    mail_screen: mail,
    // mteams: MTeams,
  },

  // Instant IM Page Icons
  instantIM: {
    whatsapp: whatsappIM,
    facebook: facebookIM,
    viber: viberIM,
    mail: mailIM,
    skype: skypeIM,
    tinder: tinderIM,
    wechat: wechatIM,
    line: lineIM,
    instagram: instagramIM,
    snapchat: snapchatIM,
    zolo: zoloIM,
    imo: imoIM,
    bip: bipIM,
    justtalk: justtalkIM,
    botim: botimIM,
    signal: signalIM,
    discord: discordIM,
    vk: vkIM,
    tiktok: tiktokIM,
    search: searchIM,
    youtube: youtubeIM,
    kakoa: kakoaIM,
    telegram: telegramIM,
    twitter: twitterIM,
    mms: mmsIM,
    googlemeet: googlemeetIM,
    qq: qqIM,
    // mteams: TeamsIM
  },

  // Shared/common icons (optional)
  //   common: {

  //   }
};

// Default export for the complete configuration
export default ICON_CONFIG;
